export function parseUnsignedInteger(value, label) {
    if (!/^(?:0|[1-9][0-9]*)$/.test(value))
        throw new TypeError(`Invalid ${label}`);
    return BigInt(value);
}
//# sourceMappingURL=parse.js.map